//react
import React, { Component } from 'react';

//components
import PopupReportASideEffect from '../../components/popup/reportASideEffect';

class AdditionalPageContent extends Component {
	constructor() {
		super();

		this.state = {
			popupCulture: 'uk',
			popupUrl: null,
		};

		this.popup = this.popup.bind(this);
		this.openPopup = this.openPopup.bind(this);
		this.closePopup = this.closePopup.bind(this);
	}

	popup() {
		if (this.state.popupUrl) {
			return (
				<PopupReportASideEffect close={this.closePopup} culture={this.state.popupCulture} url={this.state.popupUrl} />
			);
		}

		return null;
	}

	openPopup(culture, url) {
		this.setState({
			popupCulture: culture,
			popupUrl: url,
		});
	}

	closePopup(event, preventDefault) {
		if (preventDefault) {
			event.preventDefault();
		}

		this.setState({
			popupUrl: null,
		});
	}
    
    render() {
		if (this.props.culture === 'uk' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>To report to Napp, please email us at <a href="mailto:drugsafetyUKandROI@mundipharma.com">drugsafetyUKandROI@mundipharma.com</a>.  
                
                To report to the MHRA use the Yellow Card system, details can be found at <a href="https://www.mhra.gov.uk/yellowcard">www.mhra.gov.uk/yellowcard</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'uk' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
	               <div className="content-page__additional">
						<p>To report to Napp, please email us at <a href="mailto:drugsafetyUKandROI@mundipharma.com">drugsafetyUKandROI@mundipharma.com</a>.  
                
                To report to the MHRA use the Yellow Card system, details can be found at <a href="https://www.mhra.gov.uk/yellowcard">www.mhra.gov.uk/yellowcard</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		}
        

//austria - correct       
  	if (this.props.culture === 'at' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="mailto:pharm-vigilanz@ages.at">pharm-vigilanz@ages.at</a>. Unerwünschte Ereignisse sollten auch <a href="mailto:drugsafety@mundipharma.at">drugsafety@mundipharma.at</a> gemeldet werden.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'at' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        <p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="mailto:pharm-vigilanz@ages.at">pharm-vigilanz@ages.at</a>. Unerwünschte Ereignisse sollten auch <a href="mailto:drugsafety@mundipharma.at">drugsafety@mundipharma.at</a> gemeldet werden.</p>
                    </div>
					{this.popup()}
				</div>
			);
		}
// croatia check
        
        		if (this.props.culture === 'hr' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>Nuspojave bi također trebalo prijaviti <a href="mailto:drugsafetycroatia@mundipharma.com">drugsafetycroatia@mundipharma.com</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'hr' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
	               <div className="content-page__additional">
						<p>Nuspojave bi također trebalo prijaviti <a href="drugsafetycroatia@mundipharma.com">drugsafetycroatia@mundipharma.com</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		}    
        
// czech check
        
        		if (this.props.culture === 'cz' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>Nežádoucí účinky by měly být hlášeny. Formuláře pro podávání zpráv a informace naleznete na adrese <a href="https://www.uskvbl.cz/">www.uskvbl.cz</a>.
Nežádoucí účinky by měly být rovněž hlášeny <a href="mailto:phvmundi@mundipharma.cz">phvmundi@mundipharma.cz</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'cz' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
	               <div className="content-page__additional">
						<p>Nežádoucí účinky by měly být hlášeny. Formuláře pro podávání zpráv a informace naleznete na adrese <a href="https://www.uskvbl.cz/">www.uskvbl.cz</a>. 
                        Nežádoucí účinky by měly být rovněž hlášeny <a href="mailto:phvmundi@mundipharma.cz">phvmundi@mundipharma.cz</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		}
        
// denmark        
            
		if (this.props.culture === 'dk' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Hvis du er patient eller har kendskab til en patient, der har oplevet en bivirkning, overdosis eller uventet fordel forbundet med et af vores produkter, bedes du også kontakte Mundipharma ved at sende en e-mail til <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'dk' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        	<p>Hvis du er patient eller har kendskab til en patient, der har oplevet en bivirkning, overdosis eller uventet fordel forbundet med et af vores produkter, bedes du også kontakte Mundipharma ved at sende en e-mail til <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a>.</p>
                    </div>
					{this.popup()}
				</div>
			);
		}    
// estonia
        
        		if (this.props.culture === 'ee' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>Kõrvalnähtudest tuleb teatada ka aadressil <a href="mailto:drugsafetyestonia@mundipharma.com">drugsafetyestonia@mundipharma.com</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'ee' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
	               <div className="content-page__additional">
						<p>Kõrvalnähtudest tuleb teatada ka aadressil <a href="mailto:drugsafetyestonia@mundipharma.com">drugsafetyestonia@mundipharma.com</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		}
        
// germany
        
if (this.props.culture === 'de' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="https://www.bfarm.de">www.bfarm.de</a>. 
                            Unerwünschte Ereignisse sollten auch  <a href="mailto:arzneimittelsicherheit@mundipharma.de">arzneimittelsicherheit@mundipharma.de</a> gemeldet werden.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'de' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                      		<p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="https://www.bfarm.de">www.bfarm.de</a>. 
                            Unerwünschte Ereignisse sollten auch  <a href="mailto:arzneimittelsicherheit@mundipharma.de">arzneimittelsicherheit@mundipharma.de</a> gemeldet werden.</p>
                    </div>
					{this.popup()}
				</div>
			);
		}
        
// ireland
        
        if (this.props.culture === 'ie' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>To report to Mundipharma, please email us at <a href="mailto:drugsafetyUKandROI@mundipharma.com">drugsafetyUKandROI@mundipharma.com</a>.
            To report to the HPRA, details can be found at <a href="https://www.hpra.ie/homepage/about-us/report-an-issue/human-adverse-reaction-form">www.hpra.ie/homepage/about-us/report-an-issue/human-adverse-reaction-form</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'ie' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
                	<div>
					<div className="content-page__additional">
                <p>To report to Mundipharma, please email us at 
                <a href="mailto:drugsafetyUKandROI@mundipharma.com">drugsafetyUKandROI@mundipharma.com</a>.
                To report to the HPRA, details can be found at <a href="https://www.hpra.ie/homepage/about-us/report-an-issue/human-adverse-reaction-form">www.hpra.ie/homepage/about-us/report-an-issue/human-adverse-reaction-form</a>.</p>
                    </div>
                    {this.popup()}
				</div>
			);
		}
        
//italy - correct    
if (this.props.culture === 'it' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>I pazienti o le persone che sono a conoscenza di pazienti che hanno manifestato eventi avversi, sovradosaggi o benefici inaspettati dopo l'assunzione di uno dei nostri prodotti sono invitati a contattare Mundipharma inviando un'e-mail <a href="mailto:drugsafey.italy@mundipharma.it">drugsafey.italy@mundipharma.it</a></p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'it' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        <p>I pazienti o le persone che sono a conoscenza di pazienti che hanno manifestato eventi avversi, sovradosaggi o benefici inaspettati dopo l'assunzione di uno dei nostri prodotti sono invitati a contattare Mundipharma inviando un'e-mail <a href="mailto:drugsafey.italy@mundipharma.it">drugsafey.italy@mundipharma.it</a></p>
                    </div>
					{this.popup()}
				</div>
			);
		}

//latvia - check    
if (this.props.culture === 'lv' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Jāziņo par nevēlamām blakusparādībām. Ziņošanas formas un informāciju var atrast LV Zāļu valsts aģentūras (VSA) mājas lapā: <a href="https://www.zva.gov.lv/lv/zinot-par-zalu-blaknem-negadijumiem-ar-iericem-biovigilanci">https://www.zva.gov.lv/lv/zinot-par-zalu-blaknem-negadijumiem-ar-iericem-biovigilanci</a>. 
                        Par nevēlamām blakusparādībām jāziņo arī <a href="mailto:Drugsafetylatvia@mundipharma.com">Drugsafetylatvia@mundipharma.com</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'lv' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        <p>Jāziņo par nevēlamām blakusparādībām. Ziņošanas formas un informāciju var atrast LV Zāļu valsts aģentūras (VSA) mājas lapā: <a href="https://www.zva.gov.lv/lv/zinot-par-zalu-blaknem-negadijumiem-ar-iericem-biovigilanci">https://www.zva.gov.lv/lv/zinot-par-zalu-blaknem-negadijumiem-ar-iericem-biovigilanci</a>. 
                        Par nevēlamām blakusparādībām jāziņo arī <a href="mailto:Drugsafetylatvia@mundipharma.com">Drugsafetylatvia@mundipharma.com</a>.</p>
                    </div>
					{this.popup()}
				</div>
			);
		}
//luxembourg - French
if (this.props.culture === 'lu-fr' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>Les événements indésirables doivent être signalés. Les formulaires de rapport et les renseignements sont disponibles à l'adresse suivante : <a href="https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html">https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html</a>. Les événements indésirables doivent être signalés à <a href="mailto:drugsafetybenelux@mundipharma.nl">drugsafetybenelux@mundipharma.nl</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'lu-fr' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                <p>Les événements indésirables doivent être signalés. Les formulaires de rapport et les renseignements sont disponibles à l'adresse suivante : <a href="https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html">https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html</a>. Les événements indésirables doivent être signalés à <a href="mailto:drugsafetybenelux@mundipharma.nl">drugsafetybenelux@mundipharma.nl</a>.</p>
				</div>
                
                {this.popup()}
				</div>
			);
		}

//luxembourg - german
if (this.props.culture === 'lu' && this.props.section === 'hcp') {
		return (
				<div>
					<div className="content-page__additional">
						<p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html">https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html</a>. Unerwünschte Ereignisse sollten gemeldet werden an <a href="mailto:drugsafetybenelux@mundipharma.nl">drugsafetybenelux@mundipharma.nl</a>.</p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'lu' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
              	<div>
					<div className="content-page__additional">  
                        <p>Unerwünschte Ereignisse sollten gemeldet werden. Meldeformulare und Informationen finden Sie unter <a href="https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html">https://guichet.public.lu/en/entreprises/sectoriel/sante/medecins/notification-effets-indesirables-medicaments.html</a>. 
                Unerwünschte Ereignisse sollten gemeldet werden an <a href="mailto:drugsafetybenelux@mundipharma.nl">drugsafetybenelux@mundipharma.nl</a>.</p>
					</div>	
                {this.popup()}
				</div>
			);
		}
        
 //norway - correct
        
		if (this.props.culture === 'no' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Hvis du er pasient eller kjenner til en pasient som har opplevd en bivirkning, overdose eller uventet nytte av et av våre produkter, er du velkommen til å kontakte Mundipharma ved å sende en e-post til <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a></p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'no' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                       <p>Hvis du er pasient eller kjenner til en pasient som har opplevd en bivirkning, overdose eller uventet nytte av et av våre produkter, er du velkommen til å kontakte Mundipharma ved å sende en e-post til <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a></p>
                    </div>
					{this.popup()}
				</div>
			);
		}
        
//poland
        	if (this.props.culture === 'pl' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Zdarzenia niepożądane należy również zgłaszać <a href="mailto:drugsafety@mundipharma.pl">drugsafety@mundipharma.pl</a></p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'pl' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        <p>Zdarzenia niepożądane należy również zgłaszać <a href="mailto:drugsafety@mundipharma.pl">drugsafety@mundipharma.pl</a></p>
                    </div>
					{this.popup()}
				</div>
			);
		}

        
        
       
//sweden - correct     
		if (this.props.culture === 'se' && this.props.section === 'hcp') {
			return (
				<div>
					<div className="content-page__additional">
						<p>Om du är patient eller känner till en patient som har upplevt en biverkning, överdos eller oväntad nytta av en av våra produkter, vänligen kontakta Mundipharma genom att e-posta <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a></p>
					</div>
					{this.popup()}
				</div>
			);
		} else if (this.props.culture === 'se' && this.props.section === 'public' && (this.props.page === 'about' || this.props.page === 'using-nyxoid-video')) {
			return (
				<div>
					<div className="content-page__additional">
                        <p>Om du är patient eller känner till en patient som har upplevt en biverkning, överdos eller oväntad nytta av en av våra produkter, vänligen kontakta Mundipharma genom att e-posta <a href="mailto:NordicPV@mundipharma.se">NordicPV@mundipharma.se</a></p>
                    </div>
					{this.popup()}
				</div>
			);
		}


    
        
        
		return null;
	}   
    
    
    
}

export default AdditionalPageContent;



// WEBPACK FOOTER //
// ./src/components/additionalPageContent/additionalPageContent.js